import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import {Header} from '@/utils/constants/header';

/**
 * HeaderTitle component renders a title with a specified heading level.
 *
 * @param {Object} props - The component props.
 * @param {string} props.title - The title text to be displayed.
 * @param {string} [props.className] - Optional CSS class to apply to the heading element.
 * @param {Header.PageHeader|Header.SectionTitle} [props.headingLevel=Header.SectionTitle] - The heading level to use for the title.
 * @returns {JSX.Element} The rendered header title element.
 */
export const HeaderTitle = React.memo(
  ({title, className, headingLevel = Header.SectionTitle}) => {
    const getHeaderTitle = useCallback(
      (headingLevel) => {
        let headerTitle = <>{title}</>;
        if (headingLevel === Header.PageHeader) {
          headerTitle = <h1 className={className}>{title}</h1>;
        } else if (headingLevel === Header.SectionTitle) {
          headerTitle = <h2 className={className}>{title}</h2>;
        }
        return headerTitle;
      },
      [title, className]
    );
    return <>{getHeaderTitle(headingLevel)}</>;
  }
);

HeaderTitle.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  headingLevel: PropTypes.oneOf([Header.PageHeader, Header.SectionTitle])
};
